// extracted by css-extract-rspack-plugin
module.exports =  {"footer":"DetailsFooter__footer___DOxCL","buttonGroupContainer":"DetailsFooter__buttonGroupContainer___jKXdM","requestActions":"DetailsFooter__requestActions___NBRcm"};